import 'javascripts/portal_used_model';
import 'stylesheets/portal_used_model';
